module.exports = __webpack_public_path__ + "static/FMPSD-logo-186463cceaae00a38fa59c216ab111af.png";